const overviews = (axios) => {
  return {

    /**
     * @method get
     * @api /api/overviewgroups
     */
    getGroups(params) {
      return axios.get('/overviewgroups', {
        params: params,
      })
        .then((response) => response);
    },

    /**
     * @param id
     * @method post
     * @api /api/overviewgroups/remove/{id}
     */
    removeGroups(id) {
      return axios.post(`/overviewgroups/remove/${id}`)
        .then((response) => response);
    },

    /**
     * @param params
     * @method post
     * @api /api/overviewgroups/create
     */
    createGroups(params) {
      return axios.post('/overviewgroups/create', params)
        .then((response) => response);
    },

    /**
     * @param params
     * @method post
     * @api /api/overviewgroups/edit
     */
    editGroups(params) {
      return axios.post('/overviewgroups/edit', params)
        .then((response) => response);
    },

    /**
     * @param params
     * @method post
     * @api /api/overviewgroups/share
     */
    shareGroups(params) {
      return axios.post('/overviewgroups/share', params)
        .then((response) => response);
    },

    /**
     * @param params
     * @method post
     * @api /api/overviewgroups/clone
     */
    cloneGroups(params) {
      return axios.post('/overviewgroups/clone', params)
        .then((response) => response);
    },

    /**
     * @param id
     * @method post
     * @api /api/overviewgroups/restore
     */
    restoreGroups(id) {
      return axios.post('/overviewgroups/restore', id)
        .then((response) => response);
    },

    /**
     * @param id
     * @method get
     * @api /api/overviews/{id}?creation_datetime={date}
     */
    getWidgets(id, queryParams) {
      return axios.get(`/overviews/${id}`, {
        params: queryParams,
      })
        .then((response) => response);
    },

    /**
     * @param id
     * @method get
     * @api /api/overviews/get_group_name/{id}
     */
    getWidgetsName(id) {
      return axios.get(`overviews/get_group_name/${id}`)
        .then((response) => response);
    },

    /**
     * @param params
     * @method post
     * @api /api/owerviews/create
     */
    createWidgets(params) {
      return axios.post('/overviews/create', params)
        .then((response) => response);
    },

    /**
     * @param params
     * @method post
     * @api /api/owerviews/create
     */
    editWidgets(params) {
      return axios.post('/overviews/edit', params)
        .then((response) => response);
    },

    /**
     * @param id
     * @method post
     * @api /api/overview/remove/${id}
     */
    removeWidgets(id) {
      return axios.post(`/overview/remove/${id}`)
        .then((response) => response);
    },

    /**
     * @param id
     * @method post
     * @api /api/overview/restore
     */
    restoreWidgets(id) {
      return axios.post('/overview/restore', id)
        .then((response) => response);
    },

    /**
     * @method get
     * @api api/overview/get_filters
     */
    getOverviewFilters() {
      return axios.get('overview/get_filters')
        .then((resposne) => resposne);
    },
  };
};

export default overviews;
